/*
  Plan 82 P2 (L7). "Send this to whoever's buying": a link that reopens the race-course
  page on the same race, name, time and format, where the page draws the sheet again.
  The page owns every choice; this file only builds the link, reads one back, and
  hands it to the share sheet, the clipboard, or a field to copy by hand.
*/
(function () {
  'use strict';

  var FORMATS = ['print', 'framed'];

  function linkFor(choice) {
    var url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('tf_course', choice.course);
    if (choice.name) url.searchParams.set('tf_name', choice.name);
    if (choice.time) url.searchParams.set('tf_time', choice.time);
    url.searchParams.set('tf_format', choice.format);
    return url.toString();
  }

  /* The shared choices, or null when the URL carries no course. The page still
     checks each value against what it offers; nothing here builds a selector. */
  function read(search) {
    var query = new URLSearchParams(search);
    var course = query.get('tf_course');
    if (!course) return null;
    var format = query.get('tf_format');
    return {
      course: course,
      name: (query.get('tf_name') || '').trim(),
      time: (query.get('tf_time') || '').trim(),
      format: FORMATS.indexOf(format) === -1 ? null : format
    };
  }

  function mount(node, onSend) {
    var button = node.querySelector('[data-testid="hint-send"]');
    var copied = node.querySelector('[data-testid="hint-copied"]');
    var manual = node.querySelector('[data-hint-manual]');
    var field = manual.querySelector('input');
    var link = null;

    // The field sits inside the page's form; Enter there would redraw the sheet.
    field.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') event.preventDefault();
    });

    function byHand(sent) {
      if (sent !== link) return;
      field.value = sent;
      manual.hidden = false;
      field.focus();
      field.select();
    }

    function copy(sent) {
      if (!navigator.clipboard || !navigator.clipboard.writeText) return byHand(sent);
      navigator.clipboard.writeText(sent).then(function () {
        if (sent === link) copied.hidden = false;
      }, function () { byHand(sent); });
    }

    button.addEventListener('click', function () {
      var sent = link;
      copied.hidden = true;
      manual.hidden = true;
      if (onSend) onSend();
      if (typeof navigator.share !== 'function') return copy(sent);
      navigator.share({
        title: node.getAttribute('data-share-title'),
        text: node.getAttribute('data-share-text'),
        url: sent
      }).catch(function (err) {
        // Closing the share sheet is a choice, not a failure.
        if (!err || err.name !== 'AbortError') copy(sent);
      });
    });

    // No hide(): the hint sits in the preview panel, and the page hides the panel
    // whenever the sheet goes stale. show() replaces the link with the new sheet's.
    return {
      show: function (choice) {
        link = linkFor(choice);
        copied.hidden = true;
        manual.hidden = true;
        node.hidden = false;
      }
    };
  }

  window.TraceformHint = { mount: mount, read: read };
})();
